import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { initAddReclamation, addReclamation } from 'store/reclamation/reclamationsActions';
import { clearSearchPieceFilters } from 'store/pieceGestion/pieceGestionActions';
import { clearPieceGestionLignes } from 'store/pieceGestionLigne/pieceGestionLigneActions';
import { clearPiecesGestion } from 'store/pieceGestion/pieceGestionActions';
import { setClientValue } from 'store/client/clientActions';
import { setClientContact } from 'store/client/clientActions';

import AddReclamationStepper from './AddReclamationStepper';

import { TypeCodes } from 'constants.js';
import { CategorieCodes } from 'constants.js';
import { QualificationCodes } from 'constants.js';

import { Profils } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { AnomalieType } from 'constants.js';
import { TypePiece } from 'constants.js';

import localStorageHelper from 'utils/localStorageHelper';
import { sansDepotMagasin } from 'utils/depotHelper';

const Namespace = 'addReclamation';

const TypeClient = {
    id: 1, // TODO se passer de l'id
    code: TypeCodes.Client
};

const TypeCession = {
    id: 2, // TODO se passer de l'id
    code: TypeCodes.Cession
};

const TypeInterne = {
    id: 3, // TODO se passer de l'id
    code: TypeCodes.Interne
};

const CategorieDefaut = {
    id: 0, // TODO se passer de l'id
    code: ''
};

const CategorieInterne = {
    id: 6, // TODO se passer de l'id
    code: CategorieCodes.Interne
};


const QualificationDefaut = {
    id: 0, // TODO se passer de l'id
    code: ''
};

const QualificationInterne = {
    id: 22, // TODO se passer de l'id
    code: QualificationCodes.Interne
};


class AddReclamationFormContainer extends React.Component {
    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        const { reclamationLiee, infosLogistique } = this.props;

        const isDemandeTransfert = infosLogistique && infosLogistique.typePiece === 1;

        const initialState = {
            reclamation: {
                type: reclamationLiee ? { ...TypeInterne } : isDemandeTransfert ? { ...TypeCession } : { ...TypeClient },
                categorie: reclamationLiee ? { ...CategorieInterne } : { ...CategorieDefaut },
                qualification: reclamationLiee ? { ...QualificationInterne } : { ...QualificationDefaut },

                suiviNomContact: '',
                suiviEmail: '',
                suiviTelephoneMobile: '',
                commentaire: '',
                fichiersIds: [],
                client: infosLogistique ? infosLogistique.client :
                    {
                        id: 0,
                        code: '',
                        libelle: ''
                    },
                numeroPiece: infosLogistique ? infosLogistique.numeroPiece : '',
                pieceCle: infosLogistique ? infosLogistique.pieceCle || null : null,
                typePiece: infosLogistique ? infosLogistique.typePiece : null,
                ligneOuColis: 'ligne',
                lignes: [],
                colis: [],
                qualificationDetails: [],
                reclamationParentId: -1,
                groupeId: 0,
                precedenteReclamationId: null,
                retour: null
            },
            formErrors: [],
            nextStepValid: reclamationLiee ? true : false
        };

        // Réinitialisation du client dans le state Redux.
        this.props.setClientValue('', 0, false);

        // Réinitialisation des critères de recherche pour la pièce, les lignes et les critères de recherche.
        this.props.clearSearchPieceFilters();
        this.props.clearPieceGestionLignes();

        // Réinitialisation du dernier Id ajouté dans le state Redux.
        this.props.initAddReclamation();

        return initialState;
    }

    componentDidMount() {
        this.setState(this.getInitialState());
    }

    componentDidUpdate(prevProps) {

        const { nextReclamation } = this.props;

        if (prevProps.nextReclamation === null && nextReclamation !== null) {

            console.log('componentDidUpdate', nextReclamation);

            this.setState(
                {
                    ...this.state,
                    reclamation: {
                        type: { ...nextReclamation.type },
                        categorie: { ...nextReclamation.categorie },
                        qualification: { ...nextReclamation.qualification },
                        suiviNomContact: nextReclamation.suiviNomContact,
                        suiviEmail: nextReclamation.suiviEmail,
                        suiviTelephoneMobile: nextReclamation.suiviTelephoneMobile,
                        commentaire: '',
                        fichiersIds: [],
                        client: { ...nextReclamation.client },
                        numeroPiece: nextReclamation.numeroPiece !== null && nextReclamation.numeroPiece !== undefined ? nextReclamation.numeroPiece : '',
                        ligneOuColis: 'ligne',
                        lignes: [],
                        colis: [],
                        qualificationDetails: [...nextReclamation.qualificationDetails],
                        reclamationParentId: -1,
                        groupeId: 0,
                        precedenteReclamationId: nextReclamation.precedenteReclamationId,
                        retour: null
                    }
                });

        }
    }

    handleNextStepValid = (valid) => {
        this.setState({ ...this.state, nextStepValid: valid });
    }

    checkErrors(errors) {
        // On check les erreurs.
        let qualificationErrors = [];

        if (errors !== null) {
            errors.forEach(function (error) {
                if (error.errorMsg === null) {
                    // Si une erreur est présente pour le contrôle, on la supprime.
                    qualificationErrors = qualificationErrors.filter(e => e.key !== error.key);
                } else {
                    if (!qualificationErrors.find(e => e.key === error.key)) {
                        qualificationErrors.push(error);
                    }
                }
            });
        }

        return qualificationErrors;
    }

    handleCheckErrors = (errors) => {

        const qualificationErrors = this.checkErrors(errors);

        let nextStepValid = qualificationErrors.length === 0;

        this.setState({ ...this.state, formErrors: qualificationErrors, nextStepValid });
    }

    handleChange = (event, errors) => {

        this.setState((state, props) => {

            //console.log("handleChange event ", event);
            //console.log("handleChange errors ", errors);

            let newState = {
                ...state,
                reclamation: {
                    ...state.reclamation,
                    qualificationDetails: [
                        ...state.reclamation.qualificationDetails
                    ]
                }
            };

            const name = event.target.name;
            const value = event.target.value;

            //console.log("handleChange name/value ", name, value);

            // Sur changement de qualification, on réinitialise le state.
            if (name === 'qualificationId' && value !== newState.reclamation.qualification.id) {
                // On réinitialise les détails.
                if (!props.infosLogistique) {
                    newState.reclamation.numeroPiece = '';
                    newState.reclamation.pieceCle = null;
                }
                newState.reclamation.lignes = [];
                newState.reclamation.qualificationDetails = [];
                newState.reclamation.colis = [];
                newState.reclamation.ligneOuColis = "ligne";
                newState.reclamation.retour = null;
                newState.reclamation.groupeId = 0;

                // Si une qualification a été sélectionnée, on l'affecte, ainsi que l'Id.
                if (value !== 0) {
                    newState.reclamation.qualification = props.qualifications.find(x => x.id === value);
                } else {
                    newState.reclamation.qualification = { ...QualificationDefaut }
                }

                newState.formErrors = [];
                newState.nextStepValid = true;


            } else {
                // On met à jour la valeur dans la réclamation.
                newState.reclamation[name] = value;

                const qualificationErrors = this.checkErrors(errors);

                newState.formErrors = qualificationErrors;
                newState.nextStepValid = qualificationErrors.length === 0;
            }

            //console.log("handleChange newState", newState);

            return newState;
        }, () => { /*console.log("handleChange state changed");*/ });

    }

    handleQualificationDetailChange = (unOuPlusieursQualificationDetail, errors, detailsToDelete, resetPiece) => {

        this.setState((state, props) => {

            //console.log("handleQualificationDetailChange unOuPlusieursQualificationDetail ", unOuPlusieursQualificationDetail);
            //console.log("handleQualificationDetailChange errors ", errors);
            //console.log("handleQualificationDetailChange detailsToDelete ", detailsToDelete);

            //console.log("handleQualificationDetailChange state.reclamation.qualificationDetails ", state.reclamation.qualificationDetails);
            //console.log("handleQualificationDetailChange state.formErrors ", state.formErrors);

            let newState = {
                ...state,
                reclamation: {
                    ...state.reclamation,
                    qualificationDetails: [
                        ...state.reclamation.qualificationDetails
                    ]
                }
            };

            if (resetPiece) {
                if (this.props.infosLogistique === undefined) {
                    newState.reclamation.numeroPiece = '';
                    newState.reclamation.pieceCle = null;
                }
                newState.reclamation.lignes = [];
            }


            // On regarde si le détail de la qualification existe déjà grâce au code.

            if (unOuPlusieursQualificationDetail) { // Peut-être null si on cherche juste à checker les erreurs ou supprimer un détail
                if (Array.isArray(unOuPlusieursQualificationDetail)) {
                    unOuPlusieursQualificationDetail.forEach(function (qd, index) {
                        newState.reclamation.qualificationDetails = newState.reclamation.qualificationDetails.filter(d => d.code !== qd.code);
                        newState.reclamation.qualificationDetails.push(qd);
                    });

                }
                else {
                    if (newState.reclamation.qualificationDetails.find(d => d.code === unOuPlusieursQualificationDetail.code)) {
                        newState.reclamation.qualificationDetails = newState.reclamation.qualificationDetails.filter(d => d.code !== unOuPlusieursQualificationDetail.code);
                    }

                    newState.reclamation.qualificationDetails.push(unOuPlusieursQualificationDetail);
                }
            }

            // On check les erreurs.
            let qualificationErrors = Array.from(state.formErrors);
            if (errors !== null) {
                errors.forEach(function (error) {
                    if (error.errorMsg === null) {
                        // Si une erreur est présente pour le contrôle, on la supprime.
                        qualificationErrors = qualificationErrors.filter(e => e.key !== error.key);
                    } else {

                        let index = qualificationErrors.findIndex(x => x.key === error.key);
                        if (index !== -1) {
                            // La clé peut exister mais le message change
                            qualificationErrors[index].errorMsg = error.errorMsg;
                        }
                        else {
                            qualificationErrors.push(error);
                        }
                    }
                });
            }

            // Si on a des détails dont il ne faut plus tenir compte (car il dépendent d'une autre valeur d'un détail), on les supprime.
            if (detailsToDelete !== null) {
                detailsToDelete.forEach(function (detailCode) {
                    newState.reclamation.qualificationDetails = newState.reclamation.qualificationDetails.filter(d => d.code !== detailCode);
                    qualificationErrors = qualificationErrors.filter(e => e.key !== detailCode);
                    if (detailCode === ReclamationQualificationDetailCodes.NbLignes) {
                        // Si on ne veut plus du détail des lignes dans la qualification on supprimer les lignes et colis de la réclamation
                        newState.reclamation.lignes = [];
                        newState.reclamation.colis = [];
                    }
                });
            }


            // console.log("handleQualificationDetailChange qualificationDetails END", newState.reclamation.qualificationDetails);
            // console.log("handleQualificationDetailChange qualificationErrors END", qualificationErrors);


            newState.formErrors = qualificationErrors;
            newState.nextStepValid = (qualificationErrors.length === 0);


            return newState;
        }/*, () => { console.log("handleQualificationDetailChange state changed"); }*/);


    }



    handleQualificationDetailsOveride = (qualificationDetails, errors, resetPiece) => {

        this.setState((state, props) => {

            let newState = {
                ...state,
                reclamation: {
                    ...state.reclamation,
                    qualificationDetails: [
                        ...qualificationDetails
                    ]
                },
                formErrors: [...errors],
                nextStepValid: (errors.length === 0)
            };

            if (resetPiece) {
                if (this.props.infosLogistique === undefined) {
                    newState.reclamation.numeroPiece = '';
                    newState.reclamation.pieceCle = null;
                }
                newState.reclamation.lignes = [];
            }

            return newState;
        }/*, () => { console.log("handleQualificationDetailsOveride state changed"); }*/);

    }


    handleChangeType = (type, errors) => {
        const { setClientValue } = this.props;
        let reclamation = { ...this.state.reclamation };

        // Sur le changement de type, si pas d'étape client, on réinitialise le client et on force la catégorie et la qualification.
        if (type.id !== reclamation.type.id) {
            if (type.code === TypeCodes.Interne) {
                reclamation.client = {
                    id: 0,
                    code: '',
                    libelle: ''
                };

                // Réinitialisation du client dans le state Redux.
                setClientValue('', 0, false);

                // Dans le cas d'une réclamation interne, on sélectionne en dur la catégorie.
                reclamation.categorie = { ...CategorieInterne };
                reclamation.qualification = { ...QualificationDefaut };



                // On réinitialise les détails.
                reclamation.numeroPiece = '';
                reclamation.pieceCle = null;
                reclamation.lignes = [];
                reclamation.qualificationDetails = [];
                // On supprime les éventuelles erreurs liées à la catégorie.
                errors = errors.filter(x => x.key !== 'categorieId');
                errors.push({ key: 'categorieId', errorMsg: null });
            }
            else {
                // Si le type était cession ou devient cession, on réinitialise le client puisque le filtre appliqué sur la recherche de client n'est pas le même.
                if (reclamation.type.code === TypeCodes.Cession || type.code === TypeCodes.Cession)
                {
                    reclamation.client = {
                        id: 0,
                        code: '',
                        libelle: ''
                    };

                    // On passe en cession
                    if (type.code === TypeCodes.Cession) {

                        // Si l'utilisateur est un magasinier avec un dépôt unique, on sélectionne le client associer à ce dépot.
                        let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

                        if (utilisateur.codePoste === Profils.Magasinier)
                        {
                            let depotImpose = null;

                            if (sansDepotMagasin(utilisateur)) {
                                if (utilisateur.depots && utilisateur.depots.length === 1)
                                {
                                    depotImpose = utilisateur.depots[0];
                                }
                            }
                            else {
                                depotImpose = utilisateur.depot;
                            }

                            if (depotImpose && depotImpose.clientCession)
                            {
                                reclamation.client = {
                                    id: depotImpose.clientCession.id,
                                    code: depotImpose.clientCession.code,
                                    libelle: depotImpose.clientCession.libelle,
                                    chargerContact: true,
                                    verrou: true
                                };

                                // Réinitialisation du client dans le state Redux.
                                setClientValue(depotImpose.clientCession.code + ' - ' + depotImpose.clientCession.libelle, depotImpose.clientCession.id, true);
                            }
                            else {
                                // Réinitialisation du client dans le state Redux.
                                setClientValue('', 0, false);
                            }
                        }
                        else
                        {
                            // Réinitialisation du client dans le state Redux.
                            setClientValue('', 0, false);
                        }
                    }
                    else
                    {
                        // Réinitialisation du client dans le state Redux.
                        setClientValue('', 0, false);
                    }

                }

                reclamation.categorie = { ...CategorieDefaut };
                reclamation.qualification = { ...QualificationDefaut };

                // On réinitialise les détails.
                reclamation.numeroPiece = '';
                reclamation.pieceCle = null;
                reclamation.lignes = [];
                reclamation.qualificationDetails = [];
            }
        }

        reclamation.type = type;

        // On check les erreurs (la catégorie et la qualification sont réinitialisées lors du changement de type).
        const qualificationErrors = this.checkErrors(errors);

        let nextStepValid = qualificationErrors.length === 0;

        this.setState({ reclamation, formErrors: qualificationErrors, nextStepValid });
    }

    handleChangeCategorie = (categorie, errors) => {
        const { qualifications } = this.props;

        let reclamation = { ...this.state.reclamation };

        reclamation.categorie = categorie;
        reclamation.qualification = { ...QualificationDefaut };
        if (categorie) {
            // S'il n'y a qu'une qualification dans la catégorie, on la sélectionne
            let qualificationsPossibles = qualifications.filter(qualification => !qualification.desactiveCreation && qualification.categorieId === categorie.id);

            if (qualificationsPossibles && qualificationsPossibles.length === 1) {
                reclamation.qualification = qualificationsPossibles[0];

                errors = errors.filter(error => error.key !== 'qualificationId'); // On supprime l'erreur de qualification
            }

            // On check les erreurs (la qualification est réinitialisée lors du changement de catégorie, c'est la seule erreur possible).
            const qualificationErrors = this.checkErrors(errors);

            let nextStepValid = qualificationErrors.length === 0;

            this.setState({ reclamation, formErrors: qualificationErrors, nextStepValid });
        }
    }

    handleChangeClient = (client, errors) => {

        this.setState((state, props) => {

            //console.log("handleChangeClient client ", client);
            //console.log("handleChangeClient errors ", errors);

            let newState = {
                ...state,
                reclamation: {
                    ...state.reclamation,
                    lignes: [],
                    client: { ...client }
                }
            };


            // On clear les pièces et les lignes dans le state.
            props.clearPiecesGestion();
            props.clearPieceGestionLignes();

            if (client.id === 0) {
                newState.reclamation.suiviNomContact = '';
                newState.reclamation.suiviEmail = '';
                newState.reclamation.suiviTelephoneMobile = '';
            }

            // On check les erreurs.
            const qualificationErrors = this.checkErrors(errors);

            newState.formErrors = qualificationErrors;
            newState.nextStepValid = qualificationErrors.length === 0;

            //console.log("handleChangeClient newState", newState);

            return newState;
        }, () => { /*console.log("handleChangeClient state changed");*/ });

    }

    handleChangeClientContact = (id, nom, email, telephonePortable) => {
        const { setClientContact } = this.props;

        let reclamation = { ...this.state.reclamation };

        reclamation.suiviNomContact = nom ? nom : '';
        reclamation.suiviEmail = email ? email : '';
        reclamation.suiviTelephoneMobile = telephonePortable ? telephonePortable : '';

        this.setState({ reclamation: reclamation });

        setClientContact(id);
    }

    handleSelectPiece = async (value, errors, withLignes = true, typeRetour = null) => {
        const { clearPieceGestionLignes, piecesGestion } = this.props;

        let reclamation = { ...this.state.reclamation };

        // DEV-4012 : typeRetour fourni => l'utilisateur (re)choisit BL/Commande sur la pièce déjà
        // sélectionnée. On traite ce cas même si numeroPiece n'a pas changé (sinon le garde ci-dessous
        // bloquerait la mise à jour de typePiece/pieceCle).
        const memePiece = reclamation.numeroPiece === value;
        if (memePiece && typeRetour === null) {
            return;
        }

        reclamation.numeroPiece = value;

        // Récupération de la clé technique depuis la pièce sélectionnée.
        const pieceSelectionnee = piecesGestion.find(x => x.numeroPiece === value);

        if (typeRetour === TypePiece.Commande) {
            // Retour depuis la commande (DEV-4012) : on cible la commande d'origine du BL.
            reclamation.typePiece = TypePiece.Commande;
            reclamation.pieceCle = pieceSelectionnee?.commandeGestionCle || null;
        } else if (typeRetour === TypePiece.BonLivraison) {
            // Retour explicite sur le BL.
            reclamation.typePiece = TypePiece.BonLivraison;
            reclamation.pieceCle = pieceSelectionnee?.bonLivraisonGestionCle || pieceSelectionnee?.demandeTransfertGestionCle || null;
        } else {
            // Sélection initiale (clic sur la pièce) : on reprend le typePiece de la pièce.
            // Clé technique pour le backend (BL ou DT) — null en legacy (fallback sur numeroPiece).
            reclamation.typePiece = pieceSelectionnee?.typePiece ?? null;
            reclamation.pieceCle = pieceSelectionnee?.bonLivraisonGestionCle || pieceSelectionnee?.demandeTransfertGestionCle || null;
        }

        // On supprime l'erreur concernant la pièce si elle existe.
        let qualificationErrors = this.checkErrors(errors);
        qualificationErrors = qualificationErrors.filter(e => e.key !== ReclamationQualificationDetailCodes.Piece);

        // Il faut vider les lignes et ajouter une erreur sur les lignes.
        reclamation.lignes = [];
        if (withLignes) {
            qualificationErrors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Au moins une ligne doit être renseignée.' });
        }
        // On supprime également les lignes chargées dans le state redux.
        await clearPieceGestionLignes();

        const nextStepValid = qualificationErrors.length === 0;

        this.setState({ reclamation: reclamation, formErrors: qualificationErrors, nextStepValid });
    }

    handleAddLigne = (ligne, errors) => {

        const { pieceGestionLignes } = this.props;


        this.setState((state, props) => {

            let newState = { ...state };


            let reclamation = {
                ...newState.reclamation,
                lignes: newState.reclamation.lignes.filter(x => x.numeroLigne !== ligne.numeroLigne)

            };
            let pieceGestionLigne = pieceGestionLignes.find(x => x.numeroLigne === ligne.numeroLigne);


            if (pieceGestionLigne) {

                let nouvelle = {
                    ...pieceGestionLigne,
                    typeAnomalie: ligne.typeAnomalie,
                    codeArticleAnomalie: ligne.codeArticleAnomalie,
                    descriptifAnomalie: ligne.descriptifAnomalie,
                    quantiteAnomalie: ligne.quantiteAnomalie,
                    commentaireAnomalie: ligne.commentaireAnomalie,
                };


                reclamation.lignes.push(nouvelle);
            }

            // On check les erreurs.
            let qualificationErrors = this.checkErrors(errors);

            // Dans tous les cas, on supprime si on a l'erreur pas de lignes.
            qualificationErrors = qualificationErrors.filter(e => e.key !== ReclamationQualificationDetailCodes.NbLignes);



            newState.reclamation = reclamation;
            newState.formErrors = qualificationErrors;
            newState.nextStepValid = qualificationErrors.length === 0;


            return newState;
        }/*, () => { console.log("handleAddLigne state changed"); }*/);

    }

    handleRemoveLigne = (numeroLigne, errors) => {
        let reclamation = { ...this.state.reclamation };

        var lignes = reclamation.lignes.filter(l => l.numeroLigne !== numeroLigne);
        reclamation.lignes = lignes;

        // On check les erreurs.
        let qualificationErrors = this.checkErrors(errors);

        if (lignes.length === 0) {
            qualificationErrors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Au moins une ligne doit être renseignée.' });
        }

        // Pour que la saisie soit valide, il faut qu'au moins une ligne soit renseignée et si une ligne est demandée
        // et qu'il n'y ait pas d'erreur sur les autres éléments de la qualification.
        let nextStepValid = qualificationErrors.length === 0;

        this.setState({ reclamation: reclamation, formErrors: qualificationErrors, nextStepValid: nextStepValid });
    }

    handleSelectAllLignes = ({ errors, typeAnomalie = AnomalieType.DemandeRetour, commentaire = '' }) => {
        const { pieceGestionLignes } = this.props;

        this.setState((state, props) => {

            let newState = {
                ...state, reclamation: { ...state.reclamation, lignes: [...state.reclamation.lignes] }
            };

            // DEV-4012 : en mode « retour depuis commande », les lignes portent quantiteRetournable.
            // La quantité retenue par « Tout retourner » est alors le retournable (et non la quantité commandée).
            const estRetour = typeAnomalie === AnomalieType.DemandeRetourVolontaire || typeAnomalie === AnomalieType.DemandeRetour;
            const quantiteATourner = l => (l.quantiteRetournable !== undefined && l.quantiteRetournable !== null) ? l.quantiteRetournable : l.quantite;

            var lignes = pieceGestionLignes
                .filter(l => !estRetour || (l.retourExclusionFlag === 0 && quantiteATourner(l) > 0))
                .map(l => {
                    let ligne = {
                        ...l,
                        numeroLigne: l.numeroLigne,
                        typeAnomalie: typeAnomalie,
                        codeArticleAnomalie: l.codeArticle,
                        descriptifAnomalie: "",
                        quantiteAnomalie: estRetour ? quantiteATourner(l) : l.quantite,
                        commentaireAnomalie: commentaire,
                    };
                    return ligne;
                });
            newState.reclamation.lignes = lignes;

            // On check les erreurs.
            let qualificationErrors = this.checkErrors(errors);

            if (lignes.length === 0) {
                qualificationErrors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Au moins une ligne doit être renseignée.' });
            }

            newState.formErrors = qualificationErrors;
            newState.nextStepValid = qualificationErrors.length === 0;

            // Mise à jour du montant du retour
            if (typeAnomalie === AnomalieType.DemandeRetour || typeAnomalie === AnomalieType.DemandeRetourVolontaire) {

                newState.reclamation.retour = {
                    montant: Number(newState.reclamation.lignes.reduce((currentValue, nextValue) => currentValue + (nextValue.prixUnitaire * nextValue.quantiteAnomalie), 0).toFixed(2)),
                    decote: -1,
                    decoteJours: 0,
                    fdp: 0,
                    messageFDP: '',
                    autoriseJoker: false,
                    pctAvoir12Mois: 0,
                    appliquerFraisRetour: true
                };

            }
            // Attention si le bouton "tout retourner" devient "tout sélectionner", il ne faudra pas passer par ici afin de ne pas créér un noeud 'retour'
            else {

                newState.reclamation.retour = null;
            }


            return newState;
        }/*, () => { console.log("handleSelectAllLignes state changed"); }*/);

    }

    handleChangeLigneOuColis = (type) => {
        let reclamation = { ...this.state.reclamation };

        if (type !== reclamation.ligneOuColis) {
            let qualificationErrors = Array.from(this.state.formErrors);

            reclamation.ligneOuColis = type;

            if (type === 'ligne') {
                reclamation.colis = [];
                qualificationErrors = qualificationErrors.filter(e => e.key !== ReclamationQualificationDetailCodes.NbColis);
                const erreurLignes = qualificationErrors.find(e => e.key === ReclamationQualificationDetailCodes.NbLignes);
                if (erreurLignes === undefined) {
                    qualificationErrors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Au moins une ligne doit être renseignée.' });
                }
            }
            if (type === 'colis') {
                reclamation.lignes = [];
                qualificationErrors = qualificationErrors.filter(e => e.key !== ReclamationQualificationDetailCodes.NbLignes);
                const erreurColis = qualificationErrors.find(e => e.key === ReclamationQualificationDetailCodes.NbColis);
                if (erreurColis === undefined) {
                    qualificationErrors.push({ key: ReclamationQualificationDetailCodes.NbColis, errorMsg: 'Au moins un colis doit être sélectionné.' });
                }
            }
            if (type === 'tout') {
                reclamation.colis = [];
                reclamation.lignes = [];
                qualificationErrors = qualificationErrors.filter(e => e.key !== ReclamationQualificationDetailCodes.NbColis);
                qualificationErrors = qualificationErrors.filter(e => e.key !== ReclamationQualificationDetailCodes.NbLignes);
            }

            let nextStepValid = qualificationErrors.length === 0;

            this.setState({ reclamation: reclamation, formErrors: qualificationErrors, nextStepValid: nextStepValid });
        }
    }

    handleAddColis = (colisId, typeAnomalie, errors) => {
        let reclamation = { ...this.state.reclamation };

        // Si le colis n'existe pas déjà, on l'ajoute.
        let colis = reclamation.colis.find(l => l.colisId === colisId);
        if (!colis) {
            let newColis = { colisId, typeAnomalie };
            // Créer une nouvelle array au lieu de muter l'existante
            reclamation.colis = [...reclamation.colis, newColis];
        }

        // On check les erreurs.
        let qualificationErrors = this.checkErrors(errors);

        // Dans tous les cas, on supprime si on a l'erreur pas de colis.
        qualificationErrors = qualificationErrors.filter(e => e.key !== ReclamationQualificationDetailCodes.NbColis);

        const nextStepValid = qualificationErrors.length === 0;

        this.setState({ reclamation: reclamation, formErrors: qualificationErrors, nextStepValid: nextStepValid });
    }

    handleRemoveColis = (colisId, errors) => {
        let reclamation = { ...this.state.reclamation };

        var colis = reclamation.colis.filter(l => l.colisId !== colisId);
        reclamation.colis = colis;

        // On check les erreurs.
        let qualificationErrors = this.checkErrors(errors);

        if (colis.length === 0) {
            qualificationErrors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Au moins un colis doit être sélectionné.' });
        }

        // Pour que la saisie soit valide, il faut qu'au moins une ligne soit renseignée et si une ligne est demandée
        // et qu'il n'y ait pas d'erreur sur les autres éléments de la qualification.
        let nextStepValid = qualificationErrors.length === 0;

        this.setState({ reclamation: reclamation, formErrors: qualificationErrors, nextStepValid: nextStepValid });
    }

    handleAddRetour = ({ montant, decote, decoteJours, fdp, messageFDP, autoriseJoker, pctAvoir12Mois, exclusionDecote, montantRebut }) => {

        this.setState((state, props) => {

            let newState = {
                ...state,
                reclamation: {
                    ...state.reclamation,
                    retour: {
                        montant,
                        decote,
                        decoteJours,
                        fdp,
                        messageFDP,
                        autoriseJoker,
                        pctAvoir12Mois,
                        appliquerFraisRetour: true,
                        exclusionDecote,
                        montantRebut
                    }
                }
            };

            return newState;
        }/*, () => { console.log("handleAddRetour state changed"); }*/);


    }

    handleRemoveRetour = () => {

        this.setState((state, props) => {

            let newState = {
                ...state,
                reclamation: {
                    ...state.reclamation,
                    retour: null
                }
            };


            return newState;
        }/*, () => { console.log("handleRemoveRetour state changed"); }*/);

    }

    handleJokerFraisRetourChange = () => {
        let reclamation = { ...this.state.reclamation };

        reclamation.retour.appliquerFraisRetour = !reclamation.retour.appliquerFraisRetour;

        this.setState({
            ...this.state,
            reclamation: reclamation
        });
    }

    handleSubmit = async () => {
        const { addReclamation, reclamationLiee, reclamationParentId, navigate } = this.props;
        const { reclamation } = this.state;

        // Si il s'agit d'une réclamation liée, on met à jour l'Id.
        if (reclamationLiee) {
            reclamation.reclamationParentId = reclamationParentId;
        }

        // Si pas d'erreur, on ferme la fenêtre et on affiche une notification sinon on ne ferme pas et on affiche une notification.
        const result = await addReclamation(reclamation);
        if (result > 0) {
            navigate(`/reclamations/${result}`);
        }
    }

    render() {
        const { reclamationLiee, onClose, anonyme, codeAgence, autoriseSAV, utilisateurMagasin, utilisateurSelectionDepot } = this.props;

        return (
            <AddReclamationStepper
                onClose={onClose}
                reclamation={this.state.reclamation}
                onChange={this.handleChange}
                onCheckErrors={this.handleCheckErrors}
                onDetailChange={this.handleQualificationDetailChange}
                onDetailsOveride={this.handleQualificationDetailsOveride}
                onChangeClient={this.handleChangeClient}
                onChangeClientContact={this.handleChangeClientContact}
                onChangeType={this.handleChangeType}
                onChangeCategorie={this.handleChangeCategorie}
                onSelectPiece={this.handleSelectPiece}
                onAddLigne={this.handleAddLigne}
                onRemoveLigne={this.handleRemoveLigne}
                onLigneOuColisChange={this.handleChangeLigneOuColis}
                onAddColis={this.handleAddColis}
                onRemoveColis={this.handleRemoveColis}
                onSubmit={this.handleSubmit}
                validationErrors={this.state.formErrors}
                nextStepValid={this.state.nextStepValid}
                onNextStepValid={this.handleNextStepValid}
                namespace={Namespace}
                reclamationLiee={reclamationLiee}
                onSelectAllLignes={this.handleSelectAllLignes}
                onAddRetour={this.handleAddRetour}
                onRemoveRetour={this.handleRemoveRetour}
                onJokerFraisRetourChange={this.handleJokerFraisRetourChange}
                anonyme={anonyme}
                codeAgence={codeAgence}
                autoriseSAV={autoriseSAV}
                utilisateurMagasin={utilisateurMagasin}
                utilisateurSelectionDepot={utilisateurSelectionDepot}
            />
        );
    }
}

const mapDispatchToProps = dispatch => ({
    addReclamation: reclamation => dispatch(addReclamation(reclamation)),
    initAddReclamation: () => dispatch(initAddReclamation()),
    clearSearchPieceFilters: () => dispatch(clearSearchPieceFilters(Namespace)),
    clearPieceGestionLignes: () => dispatch(clearPieceGestionLignes()),
    clearPiecesGestion: () => dispatch(clearPiecesGestion(Namespace)),
    setClientValue: (value, selectedId, chargerContact, chargerContactExclusionMotif) => dispatch(setClientValue(Namespace, value, selectedId, chargerContact, chargerContactExclusionMotif)),
    setClientContact: (selectedId) => dispatch(setClientContact(Namespace, selectedId))
});



const mapStateToProps = (state, ownProps) => {

    let pieceGestionLignes = state.pieceGestionLigne.pieceGestionLignes.items;

    // Pas de namespace sur pieceGestionLignes !? Il faudra surement le corriger car c'est partager avec les infos logistiques


    const anonyme = localStorageHelper.isAnonymous();
    const codeAgence = localStorageHelper.getCodeAgence();
    const autoriseSAV = localStorageHelper.autoriseSAV();
    const utilisateurMagasin = localStorageHelper.getUtilisateurMagasin();


    return {
        redirectId: state.reclamation.reclamations.creation.reclamationAjouteeId,
        nextReclamation: state.reclamation.reclamations.creation.nextReclamation,
        qualifications: state.qualification.qualifications.items,
        pieceGestionLignes: pieceGestionLignes,
        piecesGestion: state.pieceGestion[Namespace]?.piecesGestion?.items || [],

        anonyme: anonyme,
        codeAgence: codeAgence,
        autoriseSAV: autoriseSAV,
        utilisateurMagasin: utilisateurMagasin
    };
};


AddReclamationFormContainer.propTypes = {
    onClose: PropTypes.func.isRequired,
    reclamationLiee: PropTypes.bool.isRequired,
    reclamationParentId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(AddReclamationFormContainer);